import React, { useMemo } from 'react'

import { FlickingOptions, MOVE_TYPE, Plugin } from '@egjs/flicking'
import { Arrow } from '@egjs/flicking-plugins'
import classNames from 'classnames'

import { CommonHorizontalArrowFlickingIcon } from '@local/assets/icons'

import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useClickableContext } from '@web/ui/components/Clickable/context'

import styles from './FlickingArea.module.scss'

export interface ArrowOption {
  y?: number
  moveCount?: number
  noArrow?: boolean
  hasGradient?: boolean
}
const useArrowPlugin = (
  moveType: FlickingOptions['moveType'],
  { y, moveCount, noArrow = false, hasGradient = false }: ArrowOption = {},
): [Plugin | undefined, React.FC] => {
  const Clickable = useClickableContext()
  const { isMobile } = useGlobalStaticStateContext()

  return useMemo(() => {
    if (isMobile || noArrow) return [undefined, () => null]

    const plugin = new Arrow({
      prevElSelector: `.${styles.btn_prev}`,
      nextElSelector: `.${styles.btn_next}`,
      disabledClass: styles.disabled,
      moveByViewportSize: !moveCount && moveType === MOVE_TYPE.FREE_SCROLL,
      moveCount,
    })

    const PluginComponent: React.FC = () => {
      return (
        <>
          <Clickable
            className={classNames(styles.btn_prev, {
              [styles.has_ypos]: y,
              [styles.has_gradient]: hasGradient,
            })}
          >
            <span className={styles.inner} style={{ top: y }}>
              <CommonHorizontalArrowFlickingIcon className={styles.icon} aria-hidden="true" />
              <span className="place_blind">이전</span>
            </span>
          </Clickable>
          <Clickable
            className={classNames(styles.btn_next, {
              [styles.has_ypos]: y,
              [styles.has_gradient]: hasGradient,
            })}
          >
            <span className={styles.inner} style={{ top: y }}>
              <CommonHorizontalArrowFlickingIcon className={styles.icon} aria-hidden="true" />
              <span className="place_blind">다음</span>
            </span>
          </Clickable>
        </>
      )
    }
    return [plugin, PluginComponent]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moveType, y, moveCount, isMobile])
}
export default useArrowPlugin
